export default __webpack_public_path__ + "static/media/photo4.69a870b6.jpg";